export default __webpack_public_path__ + "43a53e1d85fc9506406ebe5804aebae7.png";